export const siteGroupsPermission = {
    siteGroupsView: "site-groups.get",
    siteGroupCreate: "site-groups.create",
    siteGroupUpdate: "site-group.update",
    siteGroupDelete: "site-group.delete",
};
